import { observable, action } from 'mobx'

export type Committee = {
    nameID: number | undefined | null
    name: string
    insID: number | undefined | null
    ins: string
}

export default class {
    @observable committee: Committee[] = [
        {
            nameID: null,
            name: ``,
            insID: null,
            ins: '',
        },
    ]

    @action setCommittee = (values: Committee[]) => {
        this.committee = values
    }
}
